<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-12">
                        <div class="element-wrapper compact pt-4">
                            <h6 class="element-header">Exports</h6>
                            <div class="element-box-tp">
                                <div class="post-box">
                                    <div class="post-content">
                                        <h6 class="post-title">Products report in Excel</h6>
                                        <div class="post-foot">
                                            <span v-if="exportDownloaded" class="text-success">
                                                <i class="fas fa-check-circle"></i>
                                                Export Downloaded</span>
                                            <a class="post-link" @click="downloadExport()" v-else>
                                                <span>Download now</span>
                                                <i class="os-icon os-icon-arrow-right7"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <!-- <div class="post-content">
                                        <h6 class="post-title">Contact sheet via Email</h6>
                                        <div class="post-foot">
                                            <span v-if="emailSent" class="text-success">
                                                <i class="fas fa-check-circle"></i>
                                                Email Sent</span>
                                            <a class="post-link" @click="emailContactSheet()" v-else>
                                                <span>Send to my email</span>
                                                <i class="os-icon os-icon-arrow-right7"></i>
                                            </a>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="element-wrapper compact pt-4">
                    <h6 class="element-header">Breakdown</h6>
                    <div class="element-box-tp">
                        <table class="table table-clean">
                            <tbody>
                                <tr v-for="value,key in categories">
                                    <td>
                                        <div class="value">{{key}}</div>
                                        <span class="sub-value">Category</span>
                                    </td>
                                    <td class="text-right">
                                        <div class="value">{{value}}</div>
                                        <span class="sub-value">Count</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import LineChart from '@/config/charts/PhotoDeskBreakdownPie.js'
export default {
  props: ['products', 'session', 'type'],
  components: { LineChart },
  data: function () {
    return {
      categories: '',
      emailSent: 0,
      exportDownloaded: 0
    }
  },
  methods: {
    getProductsBreakdown: function () {
      this.categories = this.products.reduce(
        (product, o) => (
          (product[o.category_name] = (product[o.category_name] || 0) + 1),
          product
        ),
        {}
      )
    },
    emailContactSheet: function () {
      var self = this

      const url = '/photodesk/session/contactsheet'
      let data = {
        id_photodesk_session: self.session.id_photodesk_session
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.emailSent = 1
          self.$store.dispatch('updateToast', {
            text: 'Email requested',
            show: true
          })
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data.error) ||
              'Something went wrong',
            show: true
          })
        })
    },

    downloadExport: function () {
      var self = this
      const url = '/' + self.type + '/session/products/export'
      let data = {
        id_photodesk_session: self.session.id_photodesk_session && self.session.id_photodesk_session,
        id_copydesk_session: self.session.id_copydesk_session && self.session.id_copydesk_session
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          responseType: 'blob',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Export Requested',
            show: true
          })
          self.$router.push('/impexdesk/exports')
        })
        .catch(function (error) {
          self.exportDownloaded = 0
          self.$store.dispatch('updateToast', {
            text: error.response.data.error || 'Something went wrong',
            show: true
          })
        })
    }
  },
  watch: {
    products () {
      this.getProductsBreakdown()
    }
  }
}
</script>

<style scoped>
</style>
